import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createVacancyUseCase } from "../useCases/createVacancyUseCase";
import { z } from 'zod';
import { vacanciesModel } from "../entity/vacancies/VacanciesModel";

const errorsSchema = z.object({
    name: z.string().min(1, { message: "Not empty" }),
    description: z.string().nullable(),
    available: z.boolean(),
});

export const useVacanciesCreating = () => {
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({ name: '', description: '', slug: '' });
    const vacancy = vacanciesModel.current;
    const navigate = useNavigate();

    useEffect(() => {
        vacanciesModel.current = { name: '', description: '', slug: '', available: false } as any;
        return () => { vacanciesModel.current = null; }
    }, []);


    const onChange = (value: any, field: string) => {
        if (vacanciesModel.current) {
            vacanciesModel.current = { ...vacanciesModel.current, [field]: value };
            setErrors((prev) => ({ ...prev, [field]: '' }));
        }
    }

    const onCreate = async () => {
        setLoading(true);
        const result: any = errorsSchema.safeParse({ ...vacanciesModel.current });
        if (result.success && vacanciesModel.current) {
            const result = await createVacancyUseCase(vacanciesModel.current as any);
            if (!result?.isError) {
                navigate(`/dashboard/vacancies/edit/${result?.data.id}`);
            }
        } else {
            result.error.errors.map((item: any) => {
                setErrors((prev) => ({ ...prev, [item.path[0]]: item.message }));
            })
        }
        setLoading(false);
    }

    return { vacancy, errors, onChange, onCreate };

}